"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entity = exports.hasTracker = exports.hasRemoved = exports.isEntity = void 0;
const UniqueEntityID_1 = require("./UniqueEntityID");
const lodash_1 = require("lodash");
const debuggers_1 = require("../utils/debuggers");
const classDbg = debuggers_1.extendDebug(debuggers_1.getExtendedBaseDebug("Entity"));
exports.isEntity = (v) => {
    return v && typeof v === "object" && v instanceof Entity;
};
exports.hasRemoved = (v) => {
    return Object.keys(v).includes("removed");
};
exports.hasTracker = (v) => {
    return Object.keys(v).includes("tracker");
};
class Entity {
    constructor(props, ref, id) {
        this.changeNotSaved = false;
        this._id = id ? id : new UniqueEntityID_1.UniqueEntityID(); //TODO fix, id will never be null
        this._isNew = !id;
        this._ref = ref;
        this._props = props;
    }
    get ref() {
        return this._ref;
    }
    get is() {
        return typeof this._props !== "undefined";
    }
    get deleted() {
        return this._props === null;
    }
    get value() {
        return this._props;
    }
    hasRemoved() {
        return exports.hasRemoved(this._props);
    }
    hasTracker() {
        return exports.hasRemoved(this._props);
    }
    get tracker() {
        return exports.hasTracker(this._props) ? this._props.tracker : null;
    }
    get createdAt() {
        return exports.hasTracker(this._props) ? this._props.tracker.createdAt : null;
    }
    get updatedAt() {
        return exports.hasTracker(this._props) ? this._props.tracker.updatedAt : null;
    }
    get removed() {
        return exports.hasRemoved(this._props) ? this._props.removed : null;
    }
    get id() {
        return this._id;
    }
    get idStr() {
        return this._id.toString();
    }
    get isNew() {
        return this._isNew;
    }
    setNew() {
        this._isNew = true;
    }
    getTranslated(lang, name) {
        return lodash_1.get(this._props, [name, lang, "value"], "");
    }
    setTranslated(lang, name, value) {
        lodash_1.set(this._props, [name, lang], { lang, value });
    }
    getAtPath(path, defaultValue) {
        return lodash_1.get(this._props, path, defaultValue);
    }
    setAtPath(path, value) {
        lodash_1.set(this._props, path, value);
    }
    equals(object) {
        if (object == null) {
            return false;
        }
        if (this === object) {
            return true;
        }
        if (!exports.isEntity(object)) {
            return false;
        }
        return this._id.equals(object._id);
    }
    static handleValidationError(e, ref, id) {
        const dbg = classDbg("handleValidationError");
        dbg.vrbs("ref: %s/%s %o", ref, id, e);
    }
    get props() {
        return Object.keys(this._props).reduce((res, key) => {
            res[key] = typeof this[key] === "undefined" ? this._props[key] : this[key];
            return res;
        }, {});
    }
    setSaved() {
        this.changeNotSaved = false;
    }
    setNotSaved() {
        this.changeNotSaved = true;
    }
}
exports.Entity = Entity;
//# sourceMappingURL=Entity.js.map